export class ObjectStorageDestination {
    's3Bucket';
    'storageAccount';
    'gcsBucket';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "s3Bucket",
            "baseName": "s3Bucket",
            "type": "S3RestoreTarget",
            "format": ""
        },
        {
            "name": "storageAccount",
            "baseName": "storageAccount",
            "type": "StorageAccountRestoreTarget",
            "format": ""
        },
        {
            "name": "gcsBucket",
            "baseName": "gcsBucket",
            "type": "GCSRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ObjectStorageDestination.attributeTypeMap;
    }
    constructor() {
    }
}
